import { Component } from '@angular/core';

@Component({
    selector: 'app-unknown-error',
    templateUrl: './unknown-error.component.html',
    styleUrls: ['./unknown-error.component.scss'],
    standalone: false
})
export class UnknownErrorComponent  {


}
